module.exports = __webpack_public_path__ + "media/src/img/payment/googlePay-90d5b0936247b438ba76f270c0c6108c.svg";